// extracted by mini-css-extract-plugin
module.exports = {"root":"root_1-GiP"};